/* tecvan-installation.js — photo viewer for the Installation page (sections/installation.liquid) */
(function () {
  function init() {
    var root = document.querySelector('.tvis');
    if (!root || root.dataset.lbReady) return;
    var lb = root.querySelector('.lb');
    if (!lb || typeof lb.showModal !== 'function') return;
    root.dataset.lbReady = '1';
    var lbImg = lb.querySelector('img');
    var lbCap = lb.querySelector('.lb-cap');
    var set = [], idx = 0;

    function show(i) {
      idx = (i + set.length) % set.length;
      var t = set[idx];
      lbImg.src = t.dataset.full;
      lbImg.alt = t.querySelector('img').alt;
      lbCap.textContent = (t.dataset.cap || '') + '  ·  ' + (idx + 1) + ' / ' + set.length;
    }

    root.querySelectorAll('.tile').forEach(function (tile) {
      tile.addEventListener('click', function () {
        var group = tile.closest('[data-gallery]').dataset.gallery;
        set = Array.prototype.slice.call(root.querySelectorAll('[data-gallery="' + group + '"] .tile'));
        show(set.indexOf(tile));
        lb.showModal();
      });
    });

    lb.querySelector('.lb-close').addEventListener('click', function () { lb.close(); });
    lb.querySelector('.lb-prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.lb-next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb-inner')) lb.close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
